<script>
export default {
   name: 'NoSupplies',
};
</script>

<template>
   <svg xmlns="http://www.w3.org/2000/svg" width="86" height="86" fill="none" viewBox="0 0 86 86">
      <path fill="#d2ebe4" d="M38.908 47.127h-18.42L19.77 61.24l2.512 2.392h14.951l1.675-2.392z" />
      <path
         stroke="#178ece"
         stroke-linecap="round"
         stroke-linejoin="round"
         stroke-width="2"
         d="M19.525 45.988h19.922m.822-7.965-2.938-.004H20.52c-3.38 0-3.984 2.223-3.984 2.989 1.887.261 2.988.498 2.988 2.49v16.436a3.985 3.985 0 0 0 3.985 3.984h11.953a3.985 3.985 0 0 0 3.984-3.984V41.008c0-1.183.716-2.388.785-2.49.074-.119.211-.274.211-.343 0-.068-.018-.152-.174-.152"
      />
      <path fill="#e2bd4d" d="m49.293 52.162 3.56-7.295H66.06l3.896 7.295z" />
      <path
         fill="#178ece"
         d="M72.105 51.416 64.35 36.371v-7.968h1.992V26.41h-2.004v-.012l-.909.01h-9.04v1.983h1.992v7.873l-7.758 15.158a1.992 1.992 0 0 0 1.781 2.879h19.922a1.993 1.993 0 0 0 1.78-2.885M58.16 37.172l.213-.428v-8.282l3.984-.047v8.44l.22.429 3.64 7.056h-11.73zm-7.756 15.159 3.068-5.999H67.25l3.082 5.977z"
      />
      <g clip-path="url(#a)">
         <path
            fill="#bbc7d5"
            d="M43.1.945C66.23.945 85.155 19.87 85.155 43S66.23 85.055 43.1 85.055 1.045 66.13 1.045 43 19.97.945 43.1.945m0 8.411c-7.99 0-15.14 2.523-20.607 7.15l47.102 47.101C73.8 57.719 76.745 50.57 76.745 43c0-18.504-15.14-33.644-33.645-33.644m20.607 60.139L16.605 22.393C11.98 27.86 9.455 35.01 9.455 43c0 18.504 15.14 33.644 33.645 33.644 7.99 0 15.14-2.523 20.607-7.15"
         />
      </g>
      <defs>
         <clipPath id="a"><path fill="#fff" d="M.6.5h85v85H.6z" /></clipPath>
      </defs>
   </svg>
</template>

<style scoped lang="scss"></style>
